import React, { useState } from 'react';
import { Button, Modal, GoBackButton } from '../../../../components';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import FeedModalContainer from './FeedModalContainer';
import css from './CircleFeedModal.module.css';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
const CircleFeedModal = props => {
  const {
    setIsFeedModal,
    isFeedModal,
    records,
    postCommentListData,
    currentCommunityMember,
    currentIndex,
    setCurrentIndex,
    selectedPost,
    setSelectedPost,
    requestCreateComment,
    requestCreateReplyComment, 
    isredirectToLogin,
    checkCreatePostAuth,
    onDeleteBookMark,
    onCreateBookMark,
    requestDirectUpload,
    isRequestSpace,
    advancedSearchData,
    onAdvancedSearch,
    onManageDisableScrolling,
    isReplyComment = false,
    handleCloseFeedModal,
    loadMoreComments = false,
    requestPostCommentList = false,
	    isAddComment = false,
	    editCommentData = null,
    history,
    routeConfiguration,
    userModeratorsGroups,
    onPostLikeDislike,
    currentUser,
    onFetchComments,
    onSetElephantVerificationModal,
    usersBadgesMap = {},
    usersSubscriptionMap = {},
    usersStripeConnectionMap = {},
    isBasicRole = false,
    pollActionInProgressById = {},
    pollActionErrorById = {},
    onSubmitPollVote,
    onClosePoll,
  } = props;

  const handleNext = () => {
    if (currentIndex < records.length - 1) {
      const nextIndex = currentIndex + 1;
      const nextPost = records[nextIndex];
      setCurrentIndex(nextIndex);
      setSelectedPost({
        postId: nextPost?.id,
        spaceId: nextPost?.space?.id,
        index: nextIndex
      });
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      const prevIndex = currentIndex - 1;
      const prevPost = records[prevIndex];
      setCurrentIndex(prevIndex);
      setSelectedPost({
        postId: prevPost?.id,
        spaceId: prevPost?.space?.id,
        index: prevIndex
      });
    }
  };

  // Prevent modal content clicks from bubbling to navigation buttons
  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  // Find the actual post by postId instead of relying on currentIndex
  // This prevents post switching when the records array is re-sorted
  const actualPost = selectedPost?.postId 
    ? records.find(post => post.id === selectedPost.postId)
    : records[currentIndex];
  
  const actualIndex = actualPost 
    ? records.findIndex(post => post.id === actualPost.id)
    : currentIndex;

  return (
    <div>
      <Modal
        id="circleFeedModal"
        isOpen={isFeedModal}
        onClose={() => {
          handleCloseFeedModal();
        }}
        onManageDisableScrolling={onManageDisableScrolling}
        className={css.circleContainer}
      >
        <div onClick={handleModalContentClick}>
          <GoBackButton
            showAlways
            onClick={() => {
              handleCloseFeedModal();
            }}
            className={css.modalGoBackButton}
          />
          <FeedModalContainer 
            currentIndex={actualIndex}
            handleCloseFeedModal={handleCloseFeedModal}
            onPostLikeDislike={onPostLikeDislike}
            feedData={actualPost}
            selectedPost={selectedPost}
            postCommentListData={postCommentListData}
            currentCommunityMember={currentCommunityMember}
            requestCreateComment={requestCreateComment}
            requestCreateReplyComment={requestCreateReplyComment} 
            isredirectToLogin={isredirectToLogin}
            checkCreatePostAuth={checkCreatePostAuth}
            onDeleteBookMark={onDeleteBookMark}
            onCreateBookMark={onCreateBookMark}
            requestDirectUpload={requestDirectUpload}
            isRequestSpace={isRequestSpace}
            advancedSearchData={advancedSearchData}
            onAdvancedSearch={onAdvancedSearch}
            isReplyComment={isReplyComment}
	            isAddComment={isAddComment}
	            editCommentData={editCommentData}
	            loadMoreComments={loadMoreComments}
            onManageDisableScrolling={onManageDisableScrolling}
            requestPostCommentList={requestPostCommentList}
            history={history}
            routeConfiguration={routeConfiguration}
            userModeratorsGroups={userModeratorsGroups}
            currentUser={currentUser}
            onFetchComments={onFetchComments}
            onSetElephantVerificationModal={onSetElephantVerificationModal}
            userBadges={usersBadgesMap[records[currentIndex]?.author?.headline] || []}
            hasActiveSubscription={usersSubscriptionMap[records[currentIndex]?.author?.headline] || false}
            currentUserHasActiveSubscription={currentUser?.id?.uuid ? usersSubscriptionMap[currentUser.id.uuid] || isBasicRole : false}
            hasStripeConnected={usersStripeConnectionMap[records[currentIndex]?.author?.headline] || false}
            currentUserHasStripeConnected={currentUser?.id?.uuid ? usersStripeConnectionMap[currentUser.id.uuid] || false : false}
            isBasicRole={isBasicRole}
            pollActionInProgressById={pollActionInProgressById}
            pollActionErrorById={pollActionErrorById}
            onSubmitPollVote={onSubmitPollVote}
            onClosePoll={onClosePoll}
          />

          {/* Navigation buttons */}
          <div>
            <Button className={css.leftButton} onClick={handlePrev} disabled={actualIndex === 0}>
              <ProfileIconCard type="arrow_left" />
            </Button>
            <Button
              className={css.rightButton}
              onClick={handleNext}
              disabled={actualIndex === records.length - 1}
            >
              <ProfileIconCard type="arrow_right" />
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CircleFeedModal;
